<template>
<div class="popup" v-cloak v-if="editSubAccountShow" style="">
    <div class="content" id="edit-sub-account">
        <div class="title">
            <span>{{$t('language.popup.subAccountPopup.editUser.title')}}</span>
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="edit-sub-account-content">
            <div class="edit-sub-account-input">
                <input type="text" name="subAccountName" :readonly="loadingStart" v-model="subAccountName" :placeholder="$t('language.popup.subAccountPopup.editUser.namePlaceholder')"/>
            </div>
            <div class="edit-sub-account-input">
                <input type="password" name="subAccountPassword" :readonly="loadingStart" v-model="subAccountPassword" :placeholder="$t('language.common.newPassword')"/>
            </div>
        </div>
        <div class="edit-sub-account-footer">
            <button @click="editSubAccount()" v-loading="loadingStart"><span>{{$t('language.common.ok')}}</span></button>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            user: commonstate.user,
            subAccountId: "",
            subAccountName: "",
            subAccountPassword: "",
            editSubAccountShow: false,
            loadingStart: false,
        }
    },
    methods: {
        //关闭弹窗
        closePage() {
            this.editSubAccountShow = false;
            this.subAccountName = "";
            this.subAccountPassword = "";
            this.loadingStart = false;
        },
        //提交修改子账号信息请求
        editSubAccount() {
            
            let data = {
                ud: this.user.id,
                name: this.subAccountName,
                subId: this.subAccountId,
                uid: this.user.id,
            }
            if (!this.subAccountName) {
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.createNameNone'),
                    type: 'fail',
                    idValue: "edit-sub-account"
                });
                return false;
            }else if(this.subAccountName.length>20){
                 this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.createNameMore'),
                    type: 'fail',
                    idValue: "edit-sub-account"
                });
                return false;
            }    
            //填写了密码才更新密码
            if(this.subAccountPassword){
                data.password = this.subAccountPassword;
                //验证密码
                if(this.subAccountPassword.length>16||this.subAccountPassword.length<8){
                this.$toast({
                    text: this.$t('language.popup.subAccountPopup.addUser.createPasswordError'),
                    type: 'fail',
                    idValue: "edit-sub-account"
                });
                return false;
            }
            }
            
            this.loadingStart = true;
            this.Utils.doSubAccountRequest("edit", data).then(res => {
                this.loadingStart = false;
                if(res.status=="200"){
                    this.$parent.getPermissionList();
                    this.closePage();
                }else if(res.status=="400"&&res.reason=="userExist"){
                    this.$toast({
                        text: this.$t('language.popup.subAccountPopup.userExist'),
                        type: 'fail',
                        idValue: "edit-sub-account"
                    });
                }else if(res.message){
                    this.$toast({
                        text: res.message,
                        type: 'fail',
                        idValue: "edit-sub-account"
                    });       
                }else{
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "edit-sub-account"
                    });
                }
            })
        }
    }
}
</script>

<style>
#edit-sub-account {
    width: 450px;
    /*no*/
    height: 230px;
    /*no*/
}

.edit-sub-account-content {
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 15px 20px 0 20px;
    /*no*/
}

.edit-sub-account-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
}

.edit-sub-account-footer button{
    float: right;
    margin: 0 20px 20px 0;/*no*/
    width: 100px;/*no*/
}

.edit-sub-account-input {
    margin: 5px 0;/*no*/
}

#edit-sub-account .el-loading-spinner .circular {
    height: 25px !important;
    /*no*/
    width: 25px !important;
    /*no*/
}

#edit-sub-account .el-loading-spinner {
    margin-top: 0rem !important;
    top: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/sub_account_popups/edit_user_popup.vue